export default "__VITE_ASSET__DG4tV3wT__"